// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1173":"805ca150","1885":"805ca150","2066":"c8e7f12b","6018":"805ca150"}[chunkId] + ".chunk.css";
};